import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '@ztechapps/common.contract'
import type { IAction, User } from '@ztechapps/common.contract'

@InputType()
export class RemoveSchoolMemberArgs extends ActionArgs {
  /** The `User._id` of the teacher being removed from their school. */
  @Field(() => ID)
  memberId: string
}

export interface IRemoveSchoolMember extends IAction<User, RemoveSchoolMemberArgs> {}
